<template lang="pug">
v-container.pa-sm-8
  .d-flex.align-center.pb-4
    v-menu(offset-y rounded="lg")
      template(v-slot:activator="{ on }")
        v-btn.px-0(text v-on="on") 
          .heading-5.text-none.mr-1 {{ selectedDuration.text }}
          v-icon $yzi-chevron-down
      v-list.py-0(dense)
        div(v-for="duration in durations")
          v-list-item(@click="selectDuration(duration)")
            v-list-item-title.text-sm.basic800--text.font-normal {{ duration.text }} {{ dateFromDuration(duration) }}
          v-divider.basic300
    .ml-12.d-flex.align-center.overflow-y-auto
      template(v-for="status in statusSummary")
        .px-6.py-2
          v-skeleton-loader.mb-1(v-if="isLoadingSummary" max-width="24" type="text")
          .font-medium(v-else) {{ status.count }}
          .text-xs.neutral500--text {{ status.name | capitalize }}
  v-divider.mb-2.mb-md-6
  
  v-row.pb-2.pb-md-0(no-gutters)
    v-col(cols="12" md="6")
      v-tabs(v-model="customerTab" color="basic700" height="44" @change="tabChanged")
        template(v-for="status in statusSummary")
          v-tab.text-sm.font-normal.text-capitalize(active-class="font-semibold") {{ status.name | capitalize }}

    v-col(cols="12" md="6" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
        v-btn.selected-button(v-if="filtersCount" @click="clickFilter" text small)
          v-icon(size="20") $yzi-filter-funnel-01
          .ml-1 {{ filtersCount }}
        v-btn(v-else @click="clickFilter" icon color="neutral500")
          v-icon(size="20") $yzi-filter-funnel-01
        div
          customize-column-menu(:showTooltip="false" iconSize="21")
        v-menu(v-if="selectedCustomers.length" offset-y left rounded="lg" min-width=200)
          template(v-slot:activator="{ on }")
            v-btn.button-sm.ml-2(color="neutral700" outlined depressed v-on="on") {{ $t('action') }}
              v-icon(right) mdi-chevron-down
          v-list.text-sm(dense)
            v-list-item(@click="onAddSegment")
              div {{ $t('add_to_segment') }}
            v-list-item(@click="onSendSms")
              div {{ $t('send_sms') }}
            v-list-item(@click="onSendEmail")
              div {{ $t('send_email') }}
            v-list-item(@click="onDelete")
              .danger500--text {{ $t('delete') }}
            v-list-item(@click="clearSelection")
              div {{ $t('clear_selection') }}
        v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="addCustomer") {{ $t('new') }}
  v-divider
  
  .data-table
    v-data-table.mt-sm-4.pb-6(:headers="headers" :items="customers" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isLoading" item-class="text-sm" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" :hide-default-header="isMobileScreen" loader-height="2")
      template(v-slot:no-data)
        .mt-8
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.text-xs.basic600--text {{ $t('no_list_available') }}
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:header.marital_status)
        div Marital status
      template(v-slot:item="{ item, isMobile, headers, index }")
        tr.primary--text(v-if="!isMobile")
          template(v-for="header in headers")
            template(v-if="header.value === 'checked'")
              td.py-4.sticky-column
                yc-checkbox(v-model="item.checked" @change="onChecked")
            template(v-else-if="header.value === 'name'")
              td.py-4.sticky-column
                .font-medium {{ item.name }}
            template(v-else-if="header.value === 'created'")
              td.py-4 {{ item.created | convertServerDate }}
            template(v-else-if="header.value === 'member'")
              td.py-4 {{ item.member | getMemberName }}
            template(v-else-if="header.value === 'gender'")
              td.py-4 {{ item.gender | capitalize }}
            template(v-else-if="header.value === 'marital_status'")
              td.py-4 {{ item.marital_status | capitalize }}
            template(v-else)
              td.py-4 {{ getFieldData(header.value, item) }}
        
        template(v-else)
          .d-flex.py-3.align-start
            yc-checkbox(v-model="item.checked" @change="onChecked")
            .ml-4.flex-grow-1.text-sm
              .font-medium.mb-2 {{ item.name }}
              template(v-for="header in headers")
                .d-flex.mb-1(v-if="header.value !== 'checked' && header.value !== 'name'")
                  .flex-grow-1
                    .basic600--text {{ header.text | fieldNameDisplay }}
                  div(v-if="header.value === 'created'") {{ item.created | convertServerDate }}
                  div(v-else-if="header.value === 'member'") {{ item.member | getMemberName }}
                  div(v-else-if="header.value === 'gender'") {{ item.gender | capitalize }}
                  div(v-else) {{ getFieldData(header.value, item) }}
          v-divider

    .d-flex.align-center
      v-spacer
      yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Count" @input="pageChanged")
    
    y-dialog(v-if="showAddCustomerDialog" v-model="showAddCustomerDialog" max-width=568 fluid scrollable :fullscreen="$vuetify.breakpoint.xsOnly" content-class="round-2xl")
      v-card
        v-card-title.pa-4
          v-spacer 
          .text-xl.font-bold.ml-10 Add customer
          v-spacer
          v-btn(icon @click="showAddCustomerDialog = false" color="primary" small)
            v-icon mdi-close
        v-divider
        v-card-text.pb-12.primary--text
          .pt-8.pb-6
            .text-md.font-medium.mb-4 Select your source of customer
            .text-sm Choose one and click "Confirm"
          v-item-group(mandatory @change="onChanged" flat)
            div(v-for="option in addCustomerOptions" :key="option.id")
              v-item(v-slot="{ active, toggle }")
                .round-xl.pa-4.mb-3(:style="active ? activeStyle : inactiveStyle" @click="toggle" flat rounded="lg")
                  .text-md.font-medium.mb-1 {{ option.title }}
                  .text-sm.neutral500--text {{ option.description }}
        v-divider
        v-card-actions.px-6.py-3
          v-btn.button-md.underline.px-0(@click="showAddCustomerDialog = false" color="primary" text) {{ $t('cancel') }}
          v-spacer
          v-btn.button-md.white--text(@click="confirmAddCustomer" color="primary" depressed) {{ $t('confirm') }}

  delete-customer-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :customers="selectedCustomers" @deleted="successDeleteCustomer")
  add-segment-dialog(v-if="showAddDialog" :open.sync="showAddDialog" :customers="selectedCustomers" @success="successAddCustomer")
  delete-customer-segment-dialog(v-if="showDeleteCustomerSegment" :open.sync="showDeleteCustomerSegment" :customers="selectedCustomers" :segment="segment" @deleted="successDeleteCustomer")
  create-customer-dialog(v-if="showCreateCustomerDialog" :open.sync="showCreateCustomerDialog" @success="successAddCustomer")
  filter-customer-drawer(:open.sync="showFilterDrawer")

</template>

<script>
import { debounce } from '@/utils'
import { DateTime } from 'luxon'
import { mapGetters, mapActions } from 'vuex'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import DeleteCustomerDialog from '@/components/connect/dialogs/DeleteCustomerDialog.vue'
import AddSegmentDialog from '@/components/connect/dialogs/AddSegmentDialog.vue'
import DeleteCustomerSegmentDialog from '@/components/connect/dialogs/DeleteCustomerSegmentDialog.vue'
import CreateCustomerDialog from '@/components/connect/dialogs/CreateCustomerDialog.vue'
import FilterCustomerDrawer from '@/components/connect/FilterCustomerDrawer.vue'

export default {
  name: 'Customers',
  components: { CustomizeColumnMenu, DeleteCustomerDialog, AddSegmentDialog, DeleteCustomerSegmentDialog, CreateCustomerDialog, FilterCustomerDrawer },
  data: () => ({
    selectedDuration: { id: 'month', text: 'This month' },
    durations: [
      { id: 'today', text: 'Today' },
      { id: 'week', text: 'This week' },
      { id: 'month', text: 'This month' },
      { id: 'year', text: 'This year' },
      { id: 'all', text: 'All time' }
    ],
    statusSummary: [],
    isLoadingSummary: false,
    statuses: [],
    currentStatus: null,
    customerTab: 0,
    searchText: '',
    currentPage: 1,
    pageSize: 100,
    totalCount: 0,
    showSearchField: false,
    isLoading: false,
    customers: [],
    selectedCustomers: [],
    showFilterDrawer: false,
    checkAll: false,
    showDeleteDialog: false,
    showDeleteCustomerSegment: false,
    showAddDialog: false,
    showAddCustomerDialog: false,
    showCreateCustomerDialog: false,
    addCustomerOptions: [
      { 
        id: 'create',
        title: 'Add single contact', 
        description: 'Manually add a contact by filiing up required field' 
      },
      { 
        id: 'csv', 
        title: 'Upload CSV', 
        description: 'Import your customers by uploading the completed csv. file template' 
      }
    ],
    selectedAddCustomerOption: null,
    activeStyle: {
      border: '1.5px solid #0C6DFF',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    },
    inactiveStyle: {
      border: '1px solid #C1C1C1',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    }
  }),
  computed: {
    ...mapGetters({ 
      company: 'getCompany',
      fields: 'customers/getAllFields',
      filters: 'customers/getFilters'
    }),
    headers () {
      const filteredOptions = this.fields.filter(item => item.enable)
      const checkbox = {
        text: '',
        value: 'checked',
        sortable: false
      }
      const name = {
        text: 'Name',
        value: 'name',
        class: 'text-table-header'
      }
      filteredOptions.map(item => {
        item.text = item.field_name
        item.value = `${item.id}`.toLowerCase()
        item['class'] = 'text-table-header'
      })
      return [checkbox, name, ...filteredOptions]
    },
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    filtersCount () {
      let count = 0
      if (this.filters) {
        for (const key in this.filters) {
          const value = this.filters[key]
          if (value) {
            if (key === 'custom_data') {
              if (value.size) {
                count++
              }
            } else {
              count++
            }
          }
        }
      }
      return count
    }
  },
  watch: {
    pageSize () {
      this.fetchCustomers(1)
    },
    filters: {
      deep: true,
      handler () {
        this.selectedCustomers = []
        this.fetchCustomers(1)
      }
    }
  },
  mounted () {
    this.fetchSummary()
    this.fetchStatuses()
    this.fetchCustomers(1)
    this.fetchCustomFields()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchSummary () {
      this.isLoadingSummary = true
      this.$axios.get(`/connect/${this.company.slug}/statuses/summary?range=${this.selectedDuration.id}`)
        .then(resp => {
          this.statusSummary = []
          const obj = resp.data
          Object.keys(obj).forEach(key => {
            this.statusSummary.push({
              name: key,
              count: obj[key]
            })
          })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoadingSummary = false
        })
    },
    fetchStatuses () {
      this.$axios.get(`/connect/${this.company.slug}/statuses?exclude=customer&page_size=-1`)
        .then(resp => {
          this.statuses = resp.data.results
        })
    },
    fetchCustomers (page) {
      this.isLoading = true
      this.getCustomers(page, this.pageSize, this.filters)
        .then(resp => {
          const data = resp.data
          this.checkAll = false
          this.customers = data.results
          const selectedIds = this.selectedCustomers.map(item => item.id)
          this.customers.map(item => {
            item.checked = false
            if (this.previousCustomers) {
              if (this.previousCustomers.includes(item.id)) {
                item.checked = true
              }
            }
            if (selectedIds.includes(item.id)) {
              item.checked = true
            }
          })
          this.totalCount = data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchCustomFields () {
      this.$axios.get(`/connect/${this.company.slug}/customer_custom_fields?page_size=-1`)
        .then(resp => {
          if (resp.data?.results) {
            const fields = []
            resp.data.results.forEach(field => {
              field.enable = false
              fields.push(field)
            })
            this.$store.commit('customers/setCustomFields', fields)
          }
        })
        .catch(() => {})
    },
    selectDuration (duration) {
      this.selectedDuration = duration
      this.fetchSummary()
      this.fetchCustomers()
    },
    tabChanged () {
      this.searchText = null
      const currentSummary = this.statusSummary[this.customerTab]
      this.currentStatus = this.statuses.find(x => x.name === currentSummary.name)
      this.fetchCustomers(1)
    },
    dateFromDuration ({ id }) {
      const now = DateTime.local()
      switch (id) {
        case 'day':
          return `(${now.toFormat('dd MMMM yyyy')})`
        case 'week': {
          const start = DateTime.local().startOf('week')
          const startDay = start.toFormat('dd')
          const endDay = start.plus({days: 6}).toFormat('dd MMMM yyyy')
          return `(${startDay} - ${endDay})`
        }
        case 'month':
          return `(${now.toFormat('MMMM yyyy')})`
        case 'year':
          return `(${now.toFormat('yyyy')})`
        case 'all':
          return ''
      }
    },
    getCustomers (page, pageSize, filters) {
      const params = {
        page_size: pageSize,
        page,
        search: this.searchText || '',
        range: this.selectedDuration.id,
        expand: 'member'
      }
      if (this.currentStatus) {
        params['statuses'] = this.currentStatus.id
      }
      for (const key in filters) {
        const value = filters[key]
        if (value) {
          if (key === 'custom_data') {
            if (value.size) {
              const customParams = []
              for (const [filterKey, val] of value) {
                if (val) {
                  for (const k in val) {
                    const d = val[k]
                    if (d) {
                      const param = `${filterKey},${k},${d}`
                      customParams.push(param)
                    }
                  }
                }
              }
              params['custom_data'] = customParams.join('__')
            }
          } else {
            params[key] = value
          }
        }
      }
      return this.$axios.get(`/connect/${this.company.slug}/customers`, { params })
    },
    onChecked () {
      this.selectedCustomers = this.customers.filter(item => item.checked === true)
      this.customers = [...this.customers]
      this.checkAll = false
    },
    onCheckedAll () {
      const clone = [...this.customers]
      clone.map(item => item.checked = this.checkAll)
      this.customers = [...clone]
      this.selectedCustomers = this.customers.filter(item => item.checked === true)
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    clickFilter () {
      this.showFilterDrawer = true
    },
    getFieldData (id, field) {
      const data = field[id]
      if (data) {
        return data
      }
      if (field.custom_data.length) {
        const custom = field.custom_data.find(i => `${i.id}` === id)
        if (custom) {
          return custom.value
        }
      }
      return ''
    },
    pageChanged (num) {
      this.fetchCustomers(num)
    },
    queryChanged: debounce(function () {
      this.fetchCustomers(1)
    }, 750),
    clearSelection () {
      this.checkAll = false
      this.onCheckedAll()
    },
    onDelete () {
      this.showDeleteDialog = true
    },
    onDeleteCustomerSegment () {
      this.showDeleteCustomerSegment = true
    },
    onAddSegment () {
      this.showAddDialog = true
    },
    onSendSms () {
      this.$store.commit('customers/setSelectedCustomers', this.selectedCustomers)
      this.$router.push(`/admin/connect/customers/send-message`)
    },
    onSendEmail () {
      this.$store.commit('customers/setSelectedCustomers', this.selectedCustomers)
      this.$router.push(`/admin/connect/customers/send-email`)
    },
    addCustomer () {
      this.showAddCustomerDialog = true
    },
    onChanged (i) {
      this.selectedAddCustomerOption = this.addCustomerOptions[i]
    },
    confirmAddCustomer () {
      switch (this.selectedAddCustomerOption.id) {
        case 'create':
          this.showCreateCustomerDialog = true
          break
        case 'csv':
          this.$router.push('/admin/connect/customers/upload-csv')
          break
      }
    },
    successAddCustomer () {
      this.showAddCustomerDialog = false
      this.reset()
    },
    successDeleteCustomer () {
      this.reset()
    },
    reset () {
      this.checkAll = false
      this.selectedCustomers = []
      this.fetchCustomers(1)
    }
  }
}
</script>

<style scoped>
.selected-button {
  background: #EEEEEE !important;
  border-radius: 16px;
}

::v-deep svg.v-icon.notranslate.v-data-table-header__icon {
  height: 8px !important;
  width: 8px !important;
  margin-left: 8px;
}

::v-deep .v-slide-group__prev, .v-slide-group__next {
  flex: 0 1 16px !important;
  min-width: 16px !important;
}

::v-deep .v-tab {
  min-width: 24px !important;
}
</style>